import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchPolicyDocument() {
  try {
    const response = yield call(function() {
      return Api.get(`/pm/document`)
    });
    yield put({type: 'FETCH.POLICY_DOCUMENT.SUCCESS', response});
  } catch (error) {
    yield put({type: 'FETCH.POLICY_DOCUMENT.FAILURE', error});
  }
}

function* addPolicyDocumentConsent(action) {
    try {
        const {params} = action;

        yield put({type: 'ADD.POLICY_DOCUMENT_CONSENT.SUCCESS', params});
    } catch (error) {
        yield put({type: 'ADD.POLICY_DOCUMENT_CONSENT.FAILURE', error});
    }
}

function* savePolicyDocumentConsent(action) {
    try {
        const {params:{consents=[]}} = action;
        const body = {
          consents: consents.map(consent=>{
            return {
              id:consent.id,
              value:consent.value,
            }
          }),
        };
        const response = yield call(function() {
            return Api.post(`/pm/document`, body)
        });

        yield put({type: 'SAVE.POLICY_DOCUMENT_CONSENT.SUCCESS', response});
        yield put({type: 'FETCH.POLICY_DOCUMENT.REQUEST'});
    } catch (error) {
        yield put({type: 'SAVE.POLICY_DOCUMENT_CONSENT.FAILURE', error});
    }
}

export function* watchPolicyDocument() {
  yield takeEvery('FETCH.POLICY_DOCUMENT.REQUEST', fetchPolicyDocument);
  yield takeEvery('ADD.POLICY_DOCUMENT_CONSENT.REQUEST', addPolicyDocumentConsent);
  yield takeEvery('SAVE.POLICY_DOCUMENT_CONSENT.REQUEST', savePolicyDocumentConsent);
}
